/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getLiveSegment.defs.js";
export { main as default } from "./getLiveSegment.defs.js";
